import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { BREAKPOINTS } from '../utils/breakpoints';

const testimonialSwiperElements = document.querySelectorAll<HTMLElement>(
  '.content-block.content-block--testimonials.swiper',
);

testimonialSwiperElements.forEach((testimonialSwiperElement) => {
  new Swiper(testimonialSwiperElement, {
    modules: [Navigation],

    loop: true,

    navigation: {
      prevEl: testimonialSwiperElement.querySelector<HTMLButtonElement>(
        '.swiper-button-prev',
      ),
      nextEl: testimonialSwiperElement.querySelector<HTMLButtonElement>(
        '.swiper-button-next',
      ),
    },

    breakpoints: {
      [BREAKPOINTS.lg]: {
        spaceBetween: 36,
      },
    },
  });
});
